// Helpers to detect a social/video platform from a URL and build an embeddable src.

export function detectPlatform(url = "") {
  const u = url.toLowerCase();
  if (u.includes("tiktok.com")) return "tiktok";
  if (u.includes("instagram.com")) return "instagram";
  if (u.includes("youtube.com") || u.includes("youtu.be")) return "youtube";
  if (u.includes("facebook.com") || u.includes("fb.watch")) return "facebook";
  if (/\.(mp4|webm|ogg|mov)(\?|#|$)/i.test(u)) return "file";
  return "youtube";
}

export function youtubeId(url = "") {
  const m =
    url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|v\/))([\w-]{6,})/i) ||
    url.match(/[?&]v=([\w-]{6,})/i);
  return m ? m[1] : "";
}

export function tiktokId(url = "") {
  const m = url.match(/\/video\/(\d+)/) || url.match(/\/(\d{6,})/);
  return m ? m[1] : "";
}

export function instagramPath(url = "") {
  const m = url.match(/instagram\.com\/(reel|p|tv)\/([\w-]+)/i);
  return m ? `${m[1]}/${m[2]}` : "";
}

// Returns an iframe src (or the raw file url for hosted videos).
export function embedSrc(platform, url, { autoplay = false } = {}) {
  const p = platform || detectPlatform(url);
  if (p === "file") return url;
  if (p === "youtube") {
    const id = youtubeId(url);
    const base = `https://www.youtube.com/embed/${id}`;
    return autoplay
      ? `${base}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&showinfo=0&modestbranding=1&rel=0&playsinline=1`
      : `${base}?rel=0&modestbranding=1&playsinline=1`;
  }
  if (p === "tiktok") return `https://www.tiktok.com/embed/v2/${tiktokId(url)}`;
  if (p === "instagram") return `https://www.instagram.com/${instagramPath(url)}/embed`;
  if (p === "facebook")
    return `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(url)}&show_text=false&width=476`;
  return url;
}

export const PLATFORM_LABELS = {
  youtube: "YouTube",
  tiktok: "TikTok",
  instagram: "Instagram",
  facebook: "Facebook",
  file: "Uploaded video",
};

// TikTok / Instagram / Facebook reels are vertical; YouTube is landscape by default.
export function isVertical(platform) {
  return platform === "tiktok" || platform === "instagram";
}
